import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    let header = [
      <a href="#/localMerchant/home">我的店铺</a>,
      <a href="#/localMerchant/myShop">商家等级</a>,
      <a href="#/localMerchant/myShop/regular">等级规则</a>,
      '案例'
    ]

    return (
      <HeaderView title="案例" header={header}>
        <div style={{ padding: '20px 40px' }}>
          <img src="http://qnm.hunliji.com/o_1aa5v8dn611i015gm19j21eek1vmt1j.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa5v8dn6qk31n37gft1haod351k.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa5v8dn6lth8jn1dtf5or10h21l.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa5v8dn610r4dpj1jgf1uge1h921m.jpg" />
        </div>
      </HeaderView>
    )
  }
}
